import React from "react";
import {useTranslation} from "react-i18next";
import {TextInput} from "../../../FlowConfigurationInputs/TextInput/NewTextInput";


/**
 * @Description this page Object  Library's Append Action's configuration form
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRender - variable render
 * @Returns     div element
 * @Author      Onur DOGUCU
 */
function Append({action, variables, setOpenVariable,disabled}) {
    const {t} = useTranslation();
    const label = "CONTENT.CONFIGURATION-FORM.OBJECT.";
    return (
        <div>
            <div className="form-element">
                {t(label + "OBJECT-VARIABLE")}
                <TextInput
                    action={action}
                    inputName="set"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    include={['object']}
                    isRequired={true}
                    disabled={disabled}
                />
            </div>
            <div className="form-element">
                {t(label + "VARIABLE")}
                <TextInput
                    action={action}
                    inputName="item"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    isRequired={false}
                    multiline={4}
                    fieldType="object"
                    displayName={t(label + 'VARIABLE')}
                />
            </div>
        </div>
    );
}

export default Append;
